import { Image } from 'react-konva';
import useImage from "use-image";

const Bg = ()=>{
  const [image] = useImage('/assets/boardBg.jpg');
  return <Image image={image} />;
}

export default Bg;
